/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Step_BackInputs */

const en_us2_body_assessment_cue_step_back = /** @type {(inputs: Body_Assessment_Cue_Step_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step back a little.`)
};

const pt_br2_body_assessment_cue_step_back = /** @type {(inputs: Body_Assessment_Cue_Step_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afaste-se um pouco.`)
};

const es_419_body_assessment_cue_step_back = /** @type {(inputs: Body_Assessment_Cue_Step_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aléjate un poco.`)
};

const pt_pt2_body_assessment_cue_step_back = /** @type {(inputs: Body_Assessment_Cue_Step_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afasta-te um pouco.`)
};

const fr_fr2_body_assessment_cue_step_back = /** @type {(inputs: Body_Assessment_Cue_Step_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recule un peu.`)
};

const de_de2_body_assessment_cue_step_back = /** @type {(inputs: Body_Assessment_Cue_Step_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geh ein Stück zurück.`)
};

const it_it2_body_assessment_cue_step_back = /** @type {(inputs: Body_Assessment_Cue_Step_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allontanati un po'.`)
};

/**
* | output |
* | --- |
* | "Step back a little." |
*
* @param {Body_Assessment_Cue_Step_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_step_back = /** @type {((inputs?: Body_Assessment_Cue_Step_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Step_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_step_back(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_step_back(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_step_back(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_step_back(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_step_back(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_step_back(inputs)
	return en_us2_body_assessment_cue_step_back(inputs)
});
export { body_assessment_cue_step_back as "body-assessment.cue.step_back" }